var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#C9F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.25 66.9375L61.0625 75.75L75.75 55.1875M64 27.6299C55.1316 36.0516 43.321 40.6707 31.0922 40.5C29.5366 45.2391 28.746 50.1958 28.75 55.1836C28.75 77.0856 43.7273 95.4861 64 100.707C84.2727 95.49 99.25 77.0895 99.25 55.1875C99.25 50.0567 98.4275 45.1178 96.9079 40.4961H96.3125C83.7948 40.4961 72.4208 35.6081 64 27.6299Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/privacyIcon.4a303ba3152ddfde25e84159ba5ab23a.svg";
export { ForwardRef as ReactComponent };